import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation, Trans } from '@gamiphy/react-i18n';
import Profile from '@gamiphy/icons/Profile';
import Share from '@gamiphy/icons/Share';
import TwoProfiles from '@gamiphy/icons/TwoProfiles';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';

const InviteSteps: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item container alignItems="center" columnSpacing={1} wrap="nowrap">
        <Grid item>
          <Share color={ThemeStore.theme.palette?.primary?.main} />
        </Grid>
        <Grid item sx={{ fontSize: 13, fontWeight: 400 }}>
          {t('referral.tab.stepOne', 'Invite your friend to sign-up and make a purchase')}
        </Grid>
      </Grid>
      <Grid item container direction="row" alignItems="center" wrap="nowrap" spacing={1}>
        <Grid item>
          <Profile color={ThemeStore.theme?.palette?.primary?.main} />
        </Grid>
        <Grid item sx={{ fontSize: 13, fontWeight: 400 }}>
          <Trans
            i18nKey="referral.tab.yourReward.prefix"
            defaults="You earn"
          />
          <>
            <Trans
              i18nKey="referral.tab.reward.gems"
              defaults=" <bold>{{gems, gems}} </bold> "
              values={{
                gems: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
            <Trans
              i18nKey="referral.tab.reward.and.postfix"
              defaults="and"
            />
            <Trans
              i18nKey="referral.tab.reward.exp"
              defaults="<bold>{{exp, exp}} </bold>"
              values={{
                exp: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
            <Trans
              i18nKey="referral.tab.yourReward.signup"
              defaults="upon Signing up"
            />
            <Trans
              i18nKey="referral.tab.reward.andAnother.postfix"
              defaults="and another"
            />
          </>
          <>
            <>
              <Trans
                i18nKey="referral.tab.reward.gems"
                defaults=" <bold>{{gems, gems}} </bold> "
                values={{
                  gems: 100,
                }}
                components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
              />
              <Trans
                i18nKey="referral.tab.reward.and.postfix"
                defaults="and"
              />
              <Trans
                i18nKey="referral.tab.reward.exp"
                defaults="<bold>{{exp, exp}} </bold>"
                values={{
                  exp: 100,
                }}
                components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
              />
            </>
            <Trans
              i18nKey="referral.tab.yourReward.purchase"
              defaults="when your friends make a purchase"
            />
          </>
        </Grid>
      </Grid>
      <Grid item container direction="row" alignItems="center" wrap="nowrap" spacing={1}>
        <Grid item>
          <TwoProfiles color={ThemeStore.theme?.palette?.primary?.main} />
        </Grid>
        <Grid item sx={{ fontSize: 13, fontWeight: 400 }}>
          <>
            <Trans
              i18nKey="referral.tab.yourReward.referee.signup"
              defaults="Upon Signing up , they receive"
            />
            <Trans
              i18nKey="referral.preview.reward.gems"
              defaults=" <bold>{{gems, gems}} </bold> "
              values={{
                gems: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
            <Trans
              i18nKey="referral.tab.reward.and.postfix"
              defaults="and"
            />
            <Trans
              i18nKey="referral.tab.reward.exp"
              defaults="<bold>{{exp, exp}} </bold>"
              values={{
                exp: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
          </>
          <>
            <Trans
              i18nKey="referral.tab.reward.referee.purchase"
              defaults=" ,and when they make a purchase "
            />
            <Trans
              i18nKey="referral.tab.reward.referee.purchase.with.invite"
              defaults="When they make a purchase "
            />
            <Trans
              i18nKey="referral.tab.reward.referee.purchase.earn"
              defaults=",They also earn "
            />
            <Trans
              i18nKey="referral.preview.reward.gems"
              defaults=" <bold>{{gems, gems}} </bold> "
              values={{
                gems: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
            <Trans
              i18nKey="referral.tab.reward.exp"
              defaults=" and <bold>{{exp, exp}} </bold> Exp"
              values={{
                exp: 100,
              }}
              components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
            />
          </>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InviteSteps;
